export default __webpack_public_path__ + "static/media/Git_workshop.614f371f.png";